import { ca } from '@cian/analytics';

export const trackSubmitForm = () => {
  ca('eventSite', {
    action: 'Click',
    label: 'SendCode',
    category: 'IpotekaSuburban',
    name: 'oldevent',
    page: {
      pageType: 'SuburnabIpotekaLanding',
    },
  });
};
